import { NgModule } from '@angular/core';
import { LoggedInUserService } from '../auth/logged.in.user';
import { RegistrationService } from './registration.service';
import { CategoryService } from './category.service';
import { LocationService } from './location.service';
import { MatchingTenderService } from './matching.tender.service';
import { TenderService } from './tender.service';
import { SubscriptionService } from './subscription.service';
import { AccountService } from './account.service';
import { PaymentService } from './payment.service';
import { TenderTeamMemberService } from './tender.team.member.service';
import { RouterService } from './routerService';
import { MatchingContractAwardService } from './matching.contract.award.service';
import { ContractAwardService } from './contract.award.service';
import { CmsPageService } from './cms.page.service';
import { CmsHelpService } from './cms.help.service';
import { MatchingAdvertService } from './matching.advert.service';
import { CmsDialogService } from './cms.dialog.service';
import { CompetitorService } from './competitor.service';
import { CompetitorCurrentService } from './competitor.current.service';
import { CompetitorAwardsService } from './competitor.awards.service';
import { CompetitorModalService } from './competitor.modal.service';
import { TrainingService } from './training.service';
import { PaidFeatureUpsellService } from './paid.feature.upsell.service';

@NgModule({
    providers: [
        LoggedInUserService,
        RegistrationService,
        CategoryService,
        LocationService,
        MatchingTenderService,
        TenderService,
        SubscriptionService,
        AccountService,
        PaymentService,
        TenderTeamMemberService,
        RouterService,
        MatchingContractAwardService,
        ContractAwardService,
        CmsPageService,
        CmsHelpService,
        MatchingAdvertService,
        CmsDialogService,
        CompetitorService,
        CompetitorCurrentService,
        CompetitorAwardsService,
        CompetitorModalService,
        TrainingService,
        PaidFeatureUpsellService
    ]
})
export class ServiceModule { }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/service.module.ts